import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';
import './Footer.css';

const NAV_LINKS = [
  { path: '/camere', label: { ro: 'Camere', en: 'Rooms', de: 'Zimmer', fr: 'Chambres', it: 'Camere', es: 'Habitaciones' } },
  { path: '/meniu', label: { ro: 'Meniu zilnic', en: 'Daily Menu', de: 'Tagesmenü', fr: 'Menu du jour', it: 'Menu del giorno', es: 'Menú del día' } },
  { path: '/servicii', label: { ro: 'Servicii', en: 'Services', de: 'Leistungen', fr: 'Services', it: 'Servizi', es: 'Servicios' } },
  { path: '/despre', label: { ro: 'Despre noi', en: 'About', de: 'Über uns', fr: 'À propos', it: 'Chi siamo', es: 'Nosotros' } },
  { path: '/contact', label: { ro: 'Contact', en: 'Contact', de: 'Kontakt', fr: 'Contact', it: 'Contatto', es: 'Contacto' } },
];

const LEGAL_LINKS = [
  { path: '/politica-confidentialitate', label: { ro: 'Politica de Confidențialitate', en: 'Privacy Policy', de: 'Datenschutzerklärung', fr: 'Politique de confidentialité', it: 'Privacy', es: 'Privacidad' } },
  { path: '/termeni-si-conditii', label: { ro: 'Termeni și Condiții', en: 'Terms & Conditions', de: 'AGB', fr: 'Conditions générales', it: 'Termini e condizioni', es: 'Términos y condiciones' } },
  { path: '/politica-cookies', label: { ro: 'Politica de Cookie-uri', en: 'Cookie Policy', de: 'Cookie-Richtlinie', fr: 'Politique de cookies', it: 'Cookie Policy', es: 'Política de cookies' } },
];

export default function Footer() {
  const { activeLang, t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner container">
        <div className="footer__brand">
          <span className="footer__logo">Eden</span>
          <span className="footer__logo-sub">Costinești</span>
          <p className="footer__tagline">{t('site_tagline', 'La mare, cu drag')}</p>
          <div className="footer__social">
            {t('social_facebook') && (
              <a href={t('social_facebook')} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
            )}
            {t('social_instagram') && (
              <a href={t('social_instagram')} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            )}
          </div>
        </div>

        <nav className="footer__nav">
          <h4 className="footer__nav-title">
            {activeLang === 'ro' ? 'Navigare' : activeLang === 'en' ? 'Navigation' : activeLang === 'de' ? 'Navigation' : 'Navigation'}
          </h4>
          <ul>
            {NAV_LINKS.map((link) => (
              <li key={link.path}>
                <Link to={link.path}>{link.label[activeLang] || link.label.ro}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="footer__contact">
          <h4 className="footer__nav-title">Contact</h4>
          <p>{t('contact_address', '')}</p>
          <p>{t('contact_phone', '')}</p>
          <p>{t('contact_email', '')}</p>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>© {year} Casa Eden. All rights reserved.</p>
          <div className="footer__legal-links">
            {LEGAL_LINKS.map((link, i) => (
              <React.Fragment key={link.path}>
                {i > 0 && <span className="footer__legal-sep">·</span>}
                <Link to={link.path} className="footer__cookie-link">
                  {link.label[activeLang] || link.label.ro}
                </Link>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
